import styled, { css } from "styled-components";
import { colors } from "../../../consts";
import { device } from "../../../services";
import { SmallButton, WrapperContainer } from "../../../components";
import { SwitchTitleWrapper, SwitchWrapper } from "../../../components/Switcher/styled";
import { InputLabel } from "../../../components/ChipsInput/styled";

export const UserFormWrapper = styled(WrapperContainer)`
  @media screen and ${device.laptop} {
    flex-direction: column;
  }
`;

const GridStyles = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const UserFormGridContainer = styled(WrapperContainer)`
  ${(props) => props.showHistory && GridStyles}

  width: 100%;

  @media screen and ${device.tablet} {
    display: flex;
    flex-direction: column;
  }
`;

export const InputSectionWrapper = styled(WrapperContainer)`
  width: 100%;
  gap: 16px;

  align-items: flex-start;

  @media screen and ${device.tablet} {
    flex-direction: column;
  }

  ${SwitchTitleWrapper} {
    margin-bottom: 12px !important;
  }

  ${InputLabel} > div {
      position: absolute;
      right: 0;
    }
  }
`;

export const FormButton = styled(SmallButton)`
  min-width: 136px;
  font-weight: 600;

  ${(props) => props?.red && `color: ${colors.ERROR}`}
`;

export const ButtonsWrapper = styled(WrapperContainer)`
  position: absolute;
  bottom: 32px;

  box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.25);
  padding: 11px 32px 32px 0;
  margin-bottom: -32px;
  background-color: ${colors.ISABELLINE};

  @media screen and ${device.tablet} {
    padding-bottom: 32px;
  }
`;

export const ContentOverflowWrapper = styled.div`
  overflow: scroll;
  // 100 vh - title height - buttons wrapper height
  height: ${(props) =>
    props?.isNewUser
      ? "calc(100vh - 36px - 38px - 32px)"
      : "calc(100vh - 36px - 38px - 32px - 38px)"};
  padding-bottom: 91px;
`;

export const AdminSectionWrapper = styled(WrapperContainer)`
  ${SwitchWrapper} {
    flex-direction: row;
    width: unset !important;
    align-items: center !important;

    ${SwitchTitleWrapper} {
      margin-bottom: 0 !important;
      margin-right: 16px;
    }
  }
`;
